import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/fases_proyecto/fases_proyecto';
import CrearEditar from './CrearEditar';

const ms2p = (state) => {
  return {
    ...state.fases_proyecto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearEditar);